import {Component, Injector, OnInit} from '@angular/core';
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {FormsService} from "@core-services/forms.service";
import {FormQuestionFilter} from "@core/model/retailer/application-form.model";
import {
  ControlType,
  FormFileValue
} from "@features/leads/application-form-builder/add-questions/question-components.model";
import {
  SurveyFormBuilderService
} from "@features/leads/surveys/survey-view/survey-form-builder/survey-form-builder.service";
import {SurveySubmission} from "@features/leads/surveys/surveys.model";
import {PanelType} from "@shared-components/info-panel/info-panel.component";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {UtilsService} from "@shared-services/utils.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {SurveyService} from "../../survey.service";

@Component({
  selector: 'app-survey-submission-view',
  templateUrl: './survey-submission-view.component.html',
  styleUrl: './survey-submission-view.component.scss'
})
export class SurveySubmissionViewComponent extends BasePageComponent implements OnInit {

  id!: string;
  templateId!: string;
  surveySubmission!: SurveySubmission;

  constructor(injector: Injector,
              public utils: UtilsService,
              public dateUtils: DateUtilsService,
              public loader: LoadingService,
              private surveyBuilderService: SurveyFormBuilderService,
              private surveyService: SurveyService,
              public fs: FormsService) {
    super(injector);
    this.id = this.data.id;
    this.templateId = this.data.templateId;
  }

  ngOnInit() {
    this.loadSurveySubmission();
  }

  loadSurveySubmission(): void {
    this.surveyService.getOneSubmissionForSurvey(this.templateId, this.id).subscribe({
      next: data => {
        this.surveySubmission = data;
        this.fs.setRatingBars(this.surveySubmission.scoringBreakdown);
      },
      error: error => {
        console.log(error);
      }
    })
  }

  downloadFormFile(fileValue: FormFileValue, questionFilter: FormQuestionFilter) {
    this.surveyBuilderService.downloadFormFile(fileValue.fileUuid, questionFilter).subscribe({
      next: (value) => {
        const type = ('survey/' + fileValue.fileType).toString();
        const file = new Blob([value], { type });
        const fileURL = URL.createObjectURL(file);
        const anchor = document.createElement('a');

        anchor.download = fileValue.fileName;
        anchor.href = fileURL;
        anchor.click();
      },
      error: err => console.log(err)
    })
  }

  protected readonly PanelType = PanelType;
  protected readonly ControlType = ControlType;
}
